import {Component} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {HcPair} from './models/hcpair';

export interface ConfirmModel {
    title: string;
    pair: HcPair[];
}

@Component({
    selector: 'app-confirm',
    template: `
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">&times;</button>
                    <h4 class="modal-title">{{title || 'Confirm'}}</h4>
                </div>
                <div class="modal-body">
                    <table class="table">
                        <tbody>
                        <tr *ngFor="let hc of pair">
                            <td style="white-space: nowrap">{{hc.date}}</td>
                            <td>{{hc.shortname}}</td>
                            <td *ngIf="hc.longname">{{hc.longname}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="close()">Stäng</button>
                </div>
            </div>
        </div>`,
    styles: []
})
export class ConfirmComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
    title: string;
    pair: HcPair[];

    constructor(dialogService: DialogService) {
        super(dialogService);
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/confirm.component.ts